/**
 * 按一定规则将文本转换为标题
 */
export function getTitleFromText(textStr) {
    let isValid = true;
    if (!textStr || textStr.length === 0) {
        isValid = false;
    }
    // eslint-disable-next-line no-useless-escape
    const reg = /[\\\/:*?"<>|]/g;
    let newTitle = textStr.trim();
    if (reg.test(newTitle)) {
        newTitle = newTitle.replace(reg, '');
    } else if (newTitle.length > 128) {
        // 标题：：128字判断
        newTitle = newTitle.substr(0, 128);
    }

    if (newTitle.match(/^\s*$/)) {
        isValid = false;
    }

    if (!newTitle || newTitle.length === 0) {
        isValid = false;
    }
    return {
        isValid,
        newTitle,
    };
}
